import { apiClient } from './client'

type Envelope<T> = { success: true; data: T }

/** Справочник номенклатуры УНФ в микрохабе: сколько товаров и когда загружен. */
export interface NomenclatureRefStatus {
  count: number
  loadedAt: string | null
}

export interface NomenclatureRefImportResult {
  /** Товаров с артикулом — теперь в справочнике. */
  loaded: number
  /** Было в справочнике до загрузки. */
  previous: number
  /** Строк в таблице файла. */
  total: number
  /** Строк без артикула — пропущены. */
  skippedNoArticle: number
}

export async function getNomenclatureRefStatus(): Promise<NomenclatureRefStatus> {
  const res = await apiClient.get<Envelope<NomenclatureRefStatus>>('/nomenclature-ref/status')
  return res.data.data
}

export async function importNomenclatureRef(file: File): Promise<NomenclatureRefImportResult> {
  const form = new FormData()
  form.append('file', file)
  const res = await apiClient.post<Envelope<NomenclatureRefImportResult>>(
    '/nomenclature-ref/import',
    form,
    // Справочник на десятки тысяч строк заливается в одной транзакции — дольше обычного запроса.
    { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 180_000 },
  )
  return res.data.data
}
